import { INavItem } from "../../vertical/sidebar/nav-item/nav-item";

/** @ignore */
export const navItems: INavItem[] = [
    {
        displayName: "MENU.SAMPLE",
        iconName: "grid-dots",
        route: "/samples/grid",
        permissions: ["crm-samples-view"],
        cypressId: "gridSamplesNav",
    },
    {
        displayName: "MENU.ADMIN",
        iconName: "settings",
        route: "/registers/admin",
        permissions: ["crm-admin-view"],
        cypressId: "adminNav",
    },
    {
        displayName: 'MENU.LEAD',
        iconName: 'user-question',
        route: '/registers/leads',
        permissions: ['crm-leads-view'],
        cypressId: 'gridLeadsNav'
    },
    {
        displayName: 'MENU.COMMERCIAL_ACTION',
        iconName: 'file-invoice',
        route: '/registers/commercialActions',
        permissions: ['crm-commercialActions-view'],
        cypressId: 'gridCommercialActionsNav'
    },
    {
        displayName: 'MENU.PIPELINE',
        iconName: 'filter',
        route: '/registers/pipeline',
        permissions: ['crm-pipelines-view'],
        cypressId: 'gridPipelineNav'
    },
    {
        displayName: 'MENU.OPPORTUNITY',
        iconName: 'adjustments',
        permissions: ['crm-opportunities-view'],
        cypressId: 'salesFunnelNav',
        children: [
            {
                displayName: 'MENU.OPPORTUNITY_BOARD',
                iconName: 'layout-board',
                route: '/registers/opportunity',
                permissions: ['crm-opportunities-view'],
                cypressId: 'gridOpportunityNav',
            },
            {
                displayName: 'MENU.OPPORTUNITY_TRASH',
                iconName: 'trash',
                route: '/registers/opportunity/trash',
                permissions: ['crm-opportunities-view'],
                cypressId: 'opportunityTrashNav',
            },
        ],
    },
    {
        displayName: "MENU.MONACO",
        iconName: "circle-arrow-left",
        permissions: [],
        cypressId: "monacoNav",
    }
];
